import { Cliente } from '@/types';

/**
 * Get the full name of a client from the new name fields
 * Falls back to nome_completo if available, or constructs from individual fields
 */
export function getClientFullName(client: Cliente | null | undefined): string {
  if (!client) return '';

  // If nombre_completo is available (from some queries), use it
  if (client.nombre_completo) return client.nombre_completo;

  // Otherwise, construct from individual name fields
  const parts = [
    client.primer_nombre,
    client.segundo_nombre,
    client.primer_apellido,
    client.segundo_apellido,
  ].filter(Boolean);

  return parts.join(' ');
}

/**
 * Get client's address as a single string
 */
export function getClientAddress(client: Cliente | null | undefined): string {
  if (!client) return '';

  // If direccion_completa is available, use it
  if (client.direccion_completa) return client.direccion_completa;

  // Otherwise, construct from individual address fields
  const parts = [
    client.direccion,
    client.numero_puerta,
    client.ciudad,
    client.departamento,
  ].filter(Boolean);

  return parts.join(', ');
}
